import DisplayValueCurrencyCode from 'customer-data-filters-ui/components/display/DisplayValueCurrencyCode';
import FilterOperatorCurrencyCodeInput from 'customer-data-filters-ui/components/operator/FilterOperatorCurrencyCodeInput';
export default function makeCurrencyField() {
  const InputComponent = FilterOperatorCurrencyCodeInput;
  const ValueComponent = DisplayValueCurrencyCode;
  return {
    InputComponent,
    ValueComponent
  };
}